import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomFooterCell = ({ table, cell, header, footer, children, ...rest }) => {
  const { t } = useTranslation();

  const currentColumnId = header?.id

  if (currentColumnId === 'select') {
    const selectedCount = table.getSelectedRowModel().rows.length;
    const totalCount = table.getCoreRowModel().rows.length;
    const totalString = `${t('selected')}: ${selectedCount} / ${totalCount}`
    return <td {...rest} style={{minWidth: '120px'}} >{totalString}</td>
  }

  return (
    <td {...rest} >{children}</td>
  )
}

export default CustomFooterCell